"use client";

import React from "react";
import { CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  id: 1,
  title: "Search Engine Optimization (SEO)",
  description: "Enhance your online visibility and drive organic traffic with our data-backed SEO strategies tailored for growing companies. We focus on revenue-driven metrics, not just vanity rankings, ensuring your investment translates to actual business growth.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586456/img/seo_strategy_dashboard.png",
  link: "/ServicesAndSEOPage"
}, {
  id: 2,
  title: "Local SEO Dominance",
  description: "Capture local market share and attract nearby customers actively searching for your services. We optimize your digital footprint to ensure you appear prominently in local search results and map packs when prospects need you most.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586456/img/local_seo_map_search.png",
  link: "/ServicesAndSEOPage"
}, {
  id: 3,
  title: "Digital Marketing Strategy",
  description: "Align your marketing efforts with your revenue goals through a customized, full-funnel digital strategy. We analyze your market, identify opportunities, and build a comprehensive roadmap designed specifically for small and local businesses.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586456/img/digital_marketing_strategy_planning.png",
  link: "/ServicesAndSEOPage"
}];
const serviceFeatures = [{
  serviceId: 1,
  feature: "Comprehensive Keyword Research & Strategy"
}, {
  serviceId: 1,
  feature: "Technical SEO Audits & Implementation"
}, {
  serviceId: 1,
  feature: "On-Page Content Optimization"
}, {
  serviceId: 1,
  feature: "High-Quality Link Building & Authority Growth"
}, {
  serviceId: 2,
  feature: "Google Business Profile Optimization"
}, {
  serviceId: 2,
  feature: "Local Citation Building & Cleanup"
}, {
  serviceId: 2,
  feature: "Review Generation & Management Strategy"
}, {
  serviceId: 2,
  feature: "Localized Content Creation"
}, {
  serviceId: 3,
  feature: "In-depth Market & Competitor Analysis"
}, {
  serviceId: 3,
  feature: "Revenue Growth Consulting"
}, {
  serviceId: 3,
  feature: "Multi-Channel Campaign Planning"
}, {
  serviceId: 3,
  feature: "Transparent Performance Tracking & Reporting"
}];
export default function StrategicGrowthServices() {
  return <section id="strategic-growth-services" className="py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-[34px] font-sans font-bold text-primary mb-6 leading-tight">
            Strategic Growth Services
          </h2>
          <p className="text-base text-foreground/80 leading-relaxed">
            We provide comprehensive digital marketing solutions designed to
            increase your visibility, generate high-quality leads, and drive
            measurable revenue growth for your local business.
          </p>
        </div>

        <div className="flex flex-col gap-24">
          {services.map((service, index) => {
          const isEven = index % 2 === 0;
          const features = serviceFeatures.filter(f => f.serviceId === service.id);
          return <div data-index={index} key={service.id} className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                {}
                <div className={`order-2 ${isEven ? "lg:order-1" : "lg:order-2"} flex flex-col justify-center`}>
                  <h2 className="text-[34px] font-sans font-bold text-primary mb-6 leading-tight">
                    {service.title}
                  </h2>
                  <p className="text-base text-foreground/80 mb-8 leading-relaxed">
                    {service.description}
                  </p>

                  <div className="mb-8">
                    <h3 className="text-lg font-bold text-primary mb-4">
                      What's Included:
                    </h3>
                    <ul className="space-y-4">
                      {features.map((feature, fIndex) => <li data-index={fIndex} key={fIndex} className="flex items-start gap-3">
                          <CircleCheck className="w-6 h-6 text-secondary shrink-0 mt-0.5" />
                          <span className="text-base text-foreground/90">
                            {feature.feature}
                          </span>
                        </li>)}
                    </ul>
                  </div>

                  <div>
                    <Button asChild variant="default" className="rounded-none">
                      <Link to={service.link}>
                        Learn More About {service.title.split(" ")[0]}
                        <ArrowRight className="w-4 h-4 ml-2" />
                      </Link>
                    </Button>
                  </div>
                </div>

                {}
                <div className={`order-1 ${isEven ? "lg:order-2" : "lg:order-1"} relative`}>
                  <div className="relative w-full aspect-[4/3] bg-muted shadow-lg">
                    <img src={service.image} alt={`${service.title} illustration`} className="absolute inset-0 w-full h-full object-cover rounded-none" loading="lazy" />
                    {}
                    <div className={`absolute -bottom-6 ${isEven ? "-left-6" : "-right-6"} w-24 h-24 bg-secondary/10 -z-10`} aria-hidden="true" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}